import { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "./LangContext";
import { MaskLine } from "./Reveal";
import { IMAGES } from "@/data/content";

const PREVIEWS = [
  IMAGES.imageBreak,
  IMAGES.accessory,
  IMAGES.eyewear,
  IMAGES.hero,
  IMAGES.accessory,
  IMAGES.imageBreak,
];

export default function WhatWeDo() {
  const { t } = useLang();
  const [hover, setHover] = useState(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const ref = useRef(null);

  const onMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    setPos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  return (
    <section
      data-testid="what-section"
      className="relative border-t border-border px-6 py-28 md:px-12 md:py-44"
    >
      <div className="mb-16 grid grid-cols-1 gap-10 md:grid-cols-12">
        <div className="md:col-span-3">
          <span className="label">03 — What we do</span>
        </div>
        <div className="md:col-span-9">
          <h2 className="font-display text-3xl font-medium leading-[0.98] tracking-tight md:text-5xl lg:text-6xl">
            {t.what.headline.map((line, i) => (
              <MaskLine key={i} delay={i * 0.08}>
                {line}
              </MaskLine>
            ))}
          </h2>
        </div>
      </div>

      <div ref={ref} className="relative" onMouseMove={onMove}>
        <ul className="border-t border-border">
          {t.what.items.map((item, i) => (
            <motion.li
              key={item}
              data-testid={`capability-${i}`}
              data-cursor="hover"
              className="group flex items-baseline justify-between gap-4 border-b border-border py-5 md:py-7"
              onMouseEnter={() => setHover(i)}
              onMouseLeave={() => setHover(null)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-6%" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
            >
              <span
                className={`font-display text-[2rem] font-medium uppercase leading-none tracking-tight transition-all duration-500 sm:text-5xl md:text-6xl lg:text-7xl ${
                  hover === i ? "translate-x-3 text-accent md:translate-x-6" : ""
                } ${hover !== null && hover !== i ? "opacity-30" : "opacity-100"}`}
              >
                {item}
              </span>
              <span className="label shrink-0 pb-2">{String(i + 1).padStart(2, "0")}</span>
            </motion.li>
          ))}
        </ul>

        {/* Cursor-follow preview */}
        <AnimatePresence>
          {hover !== null && (
            <motion.div
              className="pointer-events-none absolute z-20 hidden h-56 w-44 overflow-hidden md:block"
              style={{ left: pos.x, top: pos.y }}
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1, x: 24, y: -110 }}
              exit={{ opacity: 0, scale: 0.85 }}
              transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            >
              <img
                src={PREVIEWS[hover]}
                alt=""
                className="h-full w-full object-cover grayscale"
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}
